import Image from 'app/Components/Shared/Image/image';
import BusinessInvoicesContext, {AccountType} from 'app/Components/Page/BusinessInvoicesPage/BusinessInvoicesContext';
import React, {memo, useEffect, useState, useContext} from 'react';
import ProviderManager from 'app/provider/providerManager';
import InnerLoader from 'app/Components/Shared/Loader/InnerLoader';

const emailRegex = /^((?!\.)[\w-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/;

const BusinessInvoicesEmail = () => {
  const [{email, selected}, dispatch] = useContext(BusinessInvoicesContext);
  const [emailAddress, setEmailAddress] = useState('');
  const [disabled, setDisabled] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);
  const [result, setResult] = useState<any>(null);
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    if (email == null) {
      setEmailAddress('');
      setResult(null);
    }
  }, [email]);

  useEffect(() => {
    setDisabled(!emailRegex.test(emailAddress));
  }, [emailAddress]);

  const sendEmail = () => {
    const companyId = selected.idNumber;
    const items = email.map((invoice) => ({
      companyId,
      invoiceOrigin: AccountType[invoice.invoiceAccountType],
      invoiceNumber: invoice.invoiceNumber,
    }));
    setLoading(true);

    const count = counter + items.length;

    dispatch({type: 'send-email', status: 'SEND', count});
    setCounter(count);

    ProviderManager.getProviderData('sendBussinessInvoicesPdf', {companyId, emailAddress, items})
      .then((res) => {
        setEmailAddress('');
        setResult(res);
        dispatch({type: 'send-email', status: res.Body ? 'SUCCESS' : 'FAILURE', count});
      })
      .catch(() => {
        setResult({Body: false});
        dispatch({type: 'send-email', status: 'FAILURE', count});
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return email == null ? null : (
    <div className='BusinessInvoicesEmail'>
      <div className='BusinessInvoicesEmail__container'>
        <Image className='BusinessInvoicesEmail__close'
          src={require('./images/icons-x.svg')}
          onClick={() => dispatch({type: 'close-email'})} />
        <InnerLoader isOverlay={true} isLoading={loading} />
        {result == null && (
          <>
            <div className='BusinessInvoicesEmail__header'>לאיזה מייל לשלוח את החשבונית?</div>
            <div className='BusinessInvoicesEmail__input'>
              <input type='email' placeholder='כתובת מייל' onChange={(e) => setEmailAddress(e.currentTarget.value)} />
            </div>
            <button className='BusinessInvoicesEmail__submit' onClick={sendEmail} disabled={disabled}>
              שליחה
            </button>
          </>
        )}

        {result != null && result.Body && (
          <>
            <Image src={require('./images/icons-sent-request.svg')} />
            <div className='BusinessInvoicesEmail__header'>מעולה, שלחנו</div>
            <button className='BusinessInvoicesEmail__submit' onClick={() => dispatch({type: 'close-email'})}>
              תודה
            </button>
          </>
        )}

        {result != null && !result.Body && (
          <>
            <div className='BusinessInvoicesEmail__header'>
              רק רגע, יש לנו תקלה בשליחה.
              <br />
              כדאי לנסות שוב עוד מעט
            </div>
            <button className='BusinessInvoicesEmail__submit' onClick={() => setResult(null)}>
              אוקיי
            </button>
          </>
        )}
      </div>
    </div>
  );
};
export default memo(BusinessInvoicesEmail);
